import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { useBrand } from '../hooks/useBrand.js';

const BrandContext = createContext();

export const BrandProvider = ({ children }) => {
  const brandConfig = useBrand();

  return (
    <BrandContext.Provider value={brandConfig}>
      {children}
    </BrandContext.Provider>
  );
};

BrandProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useBrandContext = () => {
  const context = useContext(BrandContext);
  if (context === undefined) {
    throw new Error('useBrandContext must be used within a BrandProvider');
  }
  return context; // Peut être null si aucune marque n'est détectée
};
